import script from "./SelectChannel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectChannel.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__